"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActiveBrandMap = void 0;
/* eslint-disable */
// This file is auto generated at build time. Do not edit.
const ActiveBrandMap = exports.ActiveBrandMap = {
  "aami": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/aami.3.10.0.css",
  "ahm": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/ahm.3.10.0.css",
  "austunity": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/austunity.3.10.0.css",
  "bupa": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/bupa.3.10.0.css",
  "bwm": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/bwm.3.10.0.css",
  "cba": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/cba.3.10.0.css",
  "classic": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/classic.3.10.0.css",
  "gumtree": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/gumtree.3.10.0.css",
  "hcf": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/hcf.3.10.0.css",
  "medibank": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/medibank.3.10.0.css",
  "orivet": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/orivet.3.10.0.css",
  "petbarnpica": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/petbarnpica.3.10.0.css",
  "petsure": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/petsure.3.10.0.css",
  "pia": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/pia.3.10.0.css",
  "pica": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/pica.3.10.0.css",
  "potiki": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/potiki.3.10.0.css",
  "ract": "https://utils-cdn.petsure.com.au/3.10.0/brandCssFiles/ract.3.10.0.css"
};
var _default = exports.default = {
  ActiveBrandMap
};